<template>
  <BaseFetchData :action="fetchFunnel">
    <template #default="fetchDataProps">
      <div v-if="fetchDataProps.status.resolved && funnel">
        <div class="p-8 bg-gray-800">
          <div class="max-w-5xl mx-auto">
            <div class="md:flex md:items-center md:justify-between">
              <div class="flex-1 min-w-0">
                <h2 class="text-2xl font-bold leading-7 text-white sm:text-3xl sm:truncate">
                  {{ funnel.name }}
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div class="p-8">
          <VInfographic :stages="funnel.stages" />
        </div>
      </div>
    </template>
  </BaseFetchData>
</template>

<script>
import { funnelsClient } from '@/api/clients';
import VInfographic from './_funnelId/components/VInfographic.vue';

export default {
  components: { VInfographic },
  props: {
    funnelId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      funnel: null,
    };
  },
  methods: {
    async fetchFunnel() {
      try {
        const response = await funnelsClient.read(this.funnelId, {
          include: ['stages.audiences.model', 'stages.average_audience_count'],
        });

        this.funnel = response.data;

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
